module.exports = __webpack_public_path__ + "img/flowback3.1d30f2ad.png";